import Vue from 'vue'
import Router from 'vue-router'

import login from '@/page/login'
import member from '@/page/member'
import set from '@/page/set'
import cc from '@/page/cc'
import msg from '@/page/msg'
import favorite from '@/page/favorite'
import novel from '@/page/novel'
import word from '@/page/word'
import cclist from '@/page/cclist'
import myhome from '@/page/myhome'
import user from '@/page/user'

Vue.use(Router)

const router = new Router({
	linkActiveClass: 'on',
	routes: [{
		path: '/',
		component: login,
		meta:{
			title: '登录注册 - 北域视界'
		}
	},{
		path: '/login',
		component: login,
		meta:{
			title: '登录'
		}
	},{
		path: '/member',
		component: member,
		meta:{
			title: '创作中心'
		}
	},{
		path: '/set',
		component: set,
		meta:{
			title: '我的资料'
		}
	},{
		path: '/cc',
		component: cc,
		meta:{
			title: '提示词解析'
		}
	},{
		path: '/msg',
		component: msg,
		meta:{
			title: '交流反馈'
		}
	},{
		path: '/favorite',
		component: favorite,
		meta:{
			title: '我的收藏'
		}
	},{
		path: '/novel',
		component: novel,
		meta:{
			title: '网文速览'
		}
	},{
		path: '/word',
		component: word,
		meta:{
			title: '我的提示词'
		}
	},{
		path: '/cclist',
		component: cclist,
		meta:{
			title: '提示词管理'
		}
	},{
		path: '/myhome',
		component: myhome,
		meta:{
			title: '我的主页'
		}
	},{
		path: '/userh',
		component: user,
		meta:{
			title: '会员管理'
		}
	}]
})

router.beforeEach((to, from, next) => {
	setTitle(to.meta.title);
	next()
});

export default router;

function setTitle(title){
	document.title = title;
}


// WEBPACK FOOTER //
// ./src/router/index.js